"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default() {
  var w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      width = w.innerWidth || e.clientWidth || g.clientWidth,
      height = w.innerHeight || e.clientHeight || g.clientHeight;
  return {
    width: width,
    height: height
  };
};

exports.default = _default;